const _i18n_info = {
  removeOTP: {
    EN: `OTP Removed!`,
    KO: `OTP를 지웠습니다.`,
    JP: `OTP が削除されました`
  },
  get: {
    EN: `copyed username :D.`,
    KO: `복사 완료.`,
    JP: `コピーされたユーザー名 :D.`
  },
}

const _i18n_success = {
  updated: {
    EN: `Updated.`,
    KO: `저장완료.`,
    JP: `更新しました.`
  },
  updated_2: {
    EN: `OTP_Updated.`,
    KO: `OTP 업데이트.`,
    JP: `OTP_更新済み.`
  },
}

const _i18n_warning = {
  save: {
    EN: `Nickname required.`,
    KO: `이름을 입력하세요.`,
    JP: `ニックネームは必須です`
  },
  opt_require: {
    EN: `require the OTP code`,
    KO: `require the OTP code`,
    JP: `OTPコードが必要です`
  }
}

const _i18n_error = {
  removeOT_failed : {
    EN: `Failed to remove OTP.`,
    KO: `Failed to remove OTP.`,
    JP: `OTP の削除に失敗しました`
  },
  password_match: {
    EN: `Password and Retype Password doesn\' match.`,
    KO: `새로입력한 비밀번호가 다릅니다.`,
    JP: `パスワードとパスワードの再入力が一致しません`
  },
  update_failed: {
    EN: `OTP update failed.`,
    KO: `OTP정보 저장에 실패하였습니다.`,
    JP: `OTP アップデートに失敗しました`
  },
  passwordCheck: {
    EN : `password was used, try new password`,
    KO : `password was used, try new password`,
    JP : `パスワードが使用されました。新しいパスワードをお試しくださいませ。`
  }
}

const i18n_toastr = {
  _i18n_info,
  _i18n_success,
  _i18n_warning,
  _i18n_error
}

export default i18n_toastr